<div class="smart-reporting__map">
  <div
    *ngIf="hasFilter"
    class="smart-reporting__filter"
    (click)="toggleFilter()"
    role="button"
    tabindex="0"
  >
    <span
      aria-hidden="true"
      class="icon"
      [inlineSVG]="'/assets/icons/filter.svg'"
    ></span>
    <span>{{ 'smart_reporting.filter.button' | translate }}</span>
  </div>

  <div class="smart-reporting__map__inner" #holder>
    <app-map
      (mapLoaded)="mapLoaded($event)"
      [zoom]="17"
      [maxZoom]="50"
      (mapClick)="mapClick($event)"
      [center]="[location[1], location[0]]"
    ></app-map>
  </div>
  <ng-content></ng-content>

  <div
    class="smart-reporting__overlay"
    [hidden]="!filterOpen"
    [formGroup]="filterForm"
    tabindex="-1"
  >
    <p>{{ 'smart_reporting.filter.title' | translate }}</p>
    <ul>
      <li class="own">
        <span
          aria-hidden="true"
          class="icon"
          [inlineSVG]="'/assets/icons/markers/default.svg'"
        ></span>
        <span aria-hidden="true" id="smart-reporting-own-label">{{
          'smart_reporting.filter.own' | translate
        }}</span>
        <div>
          <input
            type="checkbox"
            formControlName="own"
            id="smart-reporting-own"
          />
          <label
            role="checkbox"
            tabindex="0"
            aria-labelledby="smart-reporting-own-label"
            [attr.aria-checked]="filterForm.get('own')?.value"
            (click)="toggleCheckbox('own')"
            divClickDirective
          ></label>
        </div>
      </li>
      <li class="regular">
        <span
          aria-hidden="true"
          class="icon"
          [inlineSVG]="'/assets/icons/markers/default.svg'"
        ></span>
        <span aria-hidden="true" id="smart-reporting-regular-label">{{
          'smart_reporting.filter.regular' | translate
        }}</span>
        <div>
          <input
            type="checkbox"
            formControlName="regular"
            id="smart-reporting-regular"
          />
          <label
            role="checkbox"
            tabindex="0"
            aria-labelledby="smart-reporting-regular-label"
            [attr.aria-checked]="filterForm.get('regular')?.value"
            (click)="toggleCheckbox('regular')"
            divClickDirective
          ></label>
        </div>
      </li>
      <li class="subscribed">
        <span
          aria-hidden="true"
          class="icon"
          [inlineSVG]="'/assets/icons/markers/default.svg'"
        ></span>
        <span aria-hidden="true" id="smart-reporting-subscribed-label">{{
          'smart_reporting.filter.subscribed' | translate
        }}</span>
        <div>
          <input
            type="checkbox"
            formControlName="subscribed"
            id="smart-reporting-subscribed"
          />
          <label
            role="checkbox"
            tabindex="0"
            aria-labelledby="smart-reporting-subscribed-label"
            [attr.aria-checked]="filterForm.get('subscribed')?.value"
            (click)="toggleCheckbox('subscribed')"
            divClickDirective
          ></label>
        </div>
      </li>
    </ul>
    <button type="button" (click)="saveFilter()">
      {{ 'smart_reporting.filter.save' | translate }}
    </button>
  </div>
</div>
